export const nbsp = "\xa0";

/**
 * Returns a default amount formatting with the passed in currency.
 * @param {import('./format.js').CurrencyCode} currency
 * @return {function(number): string}
 */
export function defaultAmountFormatter(currency) {
	return function (num) {
		return num + nbsp + currency;
	};
}

/**
 *
 * @param {import("@borealis/locale-common").NMPLocale} locale
 * @param {Intl.NumberFormatOptions} opts
 * @return {Intl.NumberFormat}
 */
export const getFormatter = (locale, opts) => {
	return new Intl.NumberFormat(locale, { maximumFractionDigits: 0, ...opts });
};
